import React from "react";

const BookIcon = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0833 5.41667L7.91667 8.33333M12.0833 14.5833L7.91667 11.6667M7.91667 10C7.91667 10.5525 7.69717 11.0824 7.30647 11.4731C6.91577 11.8638 6.38587 12.0833 5.83333 12.0833C5.2808 12.0833 4.75089 11.8638 4.36019 11.4731C3.96949 11.0824 3.75 10.5525 3.75 10C3.75 9.44747 3.96949 8.91756 4.36019 8.52686C4.75089 8.13616 5.2808 7.91667 5.83333 7.91667C6.38587 7.91667 6.91577 8.13616 7.30647 8.52686C7.69717 8.91756 7.91667 9.44747 7.91667 10ZM16.25 15.4167C16.25 15.9692 16.0305 16.4991 15.6398 16.8898C15.2491 17.2805 14.7192 17.5 14.1667 17.5C13.6141 17.5 13.0842 17.2805 12.6935 16.8898C12.3028 16.4991 12.0833 15.9692 12.0833 15.4167C12.0833 14.8641 12.3028 14.3342 12.6935 13.9435C13.0842 13.5528 13.6141 13.3333 14.1667 13.3333C14.7192 13.3333 15.2491 13.5528 15.6398 13.9435C16.0305 14.3342 16.25 14.8641 16.25 15.4167ZM16.25 4.58333C16.25 5.13587 16.0305 5.66577 15.6398 6.05647C15.2491 6.44717 14.7192 6.66667 14.1667 6.66667C13.6141 6.66667 13.0842 6.44717 12.6935 6.05647C12.3028 5.66577 12.0833 5.13587 12.0833 4.58333C12.0833 4.0308 12.3028 3.50089 12.6935 3.11019C13.0842 2.71949 13.6141 2.5 14.1667 2.5C14.7192 2.5 15.2491 2.71949 15.6398 3.11019C16.0305 3.50089 16.25 4.0308 16.25 4.58333Z"
        stroke={color ? color : "white"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default BookIcon;
